if (!customElements.get('kvs-mobile-nav')) {
  class KvsMobileNav extends HTMLElement {
    connectedCallback() {
      this.phone = window.matchMedia('(max-width: 749px)');
      this.show();

      this.cart = this.closest('.section-header')?.querySelector('#cart-icon-bubble');
      this.cartSlot = this.querySelector('[data-kvs-bottom-cart-slot]');
      this.fallback = this.querySelector('[data-kvs-bottom-cart-fallback]');
      this.label = this.querySelector('[data-kvs-bottom-cart-label]');
      if (!this.cart || !this.cartSlot || !this.fallback || !this.label) return;

      this.originalCurrent = this.cart.getAttribute('aria-current');
      this.home = document.createComment('Header cart position');
      this.cart.before(this.home);
      this.onViewport = () => this.updatePosition();
      this.phone.addEventListener('change', this.onViewport);
      this.updatePosition();
    }

    updatePosition() {
      const focused = document.activeElement === this.cart;
      if (this.phone.matches) {
        this.fallback.hidden = true;
        this.label.hidden = false;
        this.cartSlot.appendChild(this.cart);
        const current = this.fallback.getAttribute('aria-current');
        if (current) this.cart.setAttribute('aria-current', current);
      } else {
        this.restoreCart();
      }
      if (focused) this.cart.focus({ preventScroll: true });
    }

    show() {
      this.classList.remove('is-hidden');
    }

    restoreCart() {
      if (this.home?.parentNode) this.home.before(this.cart);
      if (this.originalCurrent === null) this.cart?.removeAttribute('aria-current');
      else if (this.cart) this.cart.setAttribute('aria-current', this.originalCurrent);
      if (this.fallback) this.fallback.hidden = false;
      if (this.label) this.label.hidden = true;
    }

    disconnectedCallback() {
      this.show();
      this.phone?.removeEventListener('change', this.onViewport);
      this.restoreCart();
      this.home?.remove();
    }
  }

  customElements.define('kvs-mobile-nav', KvsMobileNav);
}
